<div class="relative w-full">
  <!-- Apple-inspired ambient glowing halo when success triggers -->
  @if (success()) {
    <div
      aria-hidden="true"
      class="apple-halo pointer-events-none absolute -inset-1 rounded-xl bg-jade-9/30 blur-md"
    ></div>
  }

  <button
    mat-button
    [type]="buttonType()"
    [disabled]="isInteractionDisabled()"
    (click)="onClick($event)"
    class="primary w-full apple-success-btn select-none overflow-hidden"
    [class.is-success]="success()"
    [class.is-submitting]="submitting()"
    [class]="customClass()"
    [attr.aria-busy]="submitting()"
    [attr.aria-live]="'polite'"
  >
    <div class="flex items-center justify-center gap-2.5 transition-all duration-300">
      @if (success()) {
        <!-- Apple animated vector checkmark -->
        <svg
          class="apple-icon-bounce size-5 shrink-0 text-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
        >
          <!-- Outer circle drawn with stroke-dashoffset -->
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="2"
            class="apple-circle stroke-white/40"
          />
          <!-- Apple checkmark path drawn with stroke-dashoffset -->
          <path
            d="M7 12.5L10.5 16L17.5 8.5"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="apple-check stroke-white"
          />
        </svg>
        <span class="apple-fade-in text-sm font-semibold tracking-tight text-white">
          {{ successLabel() }}
        </span>
      } @else if (submitting()) {
        <!-- Minimalist Apple circular spinner -->
        <svg
          class="size-5 shrink-0 animate-spin text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" />
          <path class="opacity-90" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
        <span class="text-sm font-semibold tracking-tight text-white/90"> Veuillez patienter... </span>
      } @else {
        <span class="text-sm font-semibold tracking-tight">
          {{ label() }}
        </span>
      }
    </div>
  </button>
</div>
